import * as R from 'ramda'
import { useCallback, useEffect, useState } from 'react'

import { useCreatingRoleDialogState } from './useCreatingRoleDialogState'

export const useRoleTable = () => {
  const [editingData, setEditingData] = useState(undefined)

  const {
    state: { isOpenCreatingRoleDialog },
    setState: setStateCreatingDialog,
  } = useCreatingRoleDialogState()

  const closeRoleFormDialog = useCallback(() => {
    setEditingData(undefined)
    setStateCreatingDialog({ isOpenCreatingRoleDialog: false })
  }, [setStateCreatingDialog])

  const openCreatingRoleDialog = useCallback(() => {
    setEditingData({})
  }, [])

  useEffect(() => {
    R.ifElse(
      R.equals(true),
      openCreatingRoleDialog,
      closeRoleFormDialog,
    )(isOpenCreatingRoleDialog)
  }, [closeRoleFormDialog, isOpenCreatingRoleDialog, openCreatingRoleDialog])

  return {
    editingData,
    openUpdatingRoleDialog: setEditingData,
    closeRoleFormDialog,
    openCreatingRoleDialog,
  }
}
